import { Alignment } from 'domain/constants/alignment';
import { Layout } from 'domain/constants/layout';
import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

const scroller = {
  default: css`
    padding-top: ${cssTheme.gu2};
  `,
  centerAligned: css`
    text-align: center;
  `,
};
export default ({ layout: { alignment } }: { layout: Layout }) => {
  return {
    scroller: cx(scroller.default, alignment === Alignment.CENTER && scroller.centerAligned),
  };
};
